import AUDIO_INSTRUCTIONS from '../constants/audio';

/* Accuracy audio */
import accuracyReadyInstruction from '../sounds/rct_accuracy_ready.mp3';
import accuracyQuestionsInstruction from '../sounds/rct_accuracy_question_instruction.mp3';
import accuracyPracticeStartInstruction from '../sounds/rct_accuracy_practice_start.mp3';
import accuracyPracticeCorrectResponse from '../sounds/rct_accuracy_practice_correct.mp3';
import accuracyPracticeFirstIncorrect from '../sounds/rct_accuracy_practice_incorrect_1.mp3';
import accuracyPracticeSecondIncorrect from '../sounds/rct_accuracy_practice_incorrect_2.mp3';
import accuracyAnswerHot from '../sounds/rct_accuracy_model_hot.mp3';
import accuracyAnswerPan from '../sounds/rct_accuracy_model_pan.mp3';
import accuracyAnswerRib from '../sounds/rct_accuracy_model_rib.mp3';
import avatarStartModel from '../sounds/rct_accuracy_model_instruction.mp3';
import avatarInstructionModel from '../sounds/rct_accuracy_model_click_correct.mp3';
import avatarDirectionInstruction from '../sounds/rct_accuracy_direction.mp3';

/* Fluency audio */
import fluencyReady from '../sounds/rct_fluency_ready.mp3';
import fluencyDirectionInstruction from '../sounds/rct_fluency_direction.mp3';
import fluencyModelInstruction from '../sounds/rct_fluency_model_instruction.mp3';
import fluencyModelInstructionReplay from '../sounds/rct_fluency_model_instruction_replay.mp3';
import fluencyModelAnswerInstruction from '../sounds/rct_fluency_model_answer_instruction.mp3';
import fluencyModelComplete from '../sounds/rct_fluency_model_complete.mp3';
import fluencyPracticeInstruction from '../sounds/rct_fluency_practice_instruction.mp3';
import fluencyPracticeComplete from '../sounds/rct_fluency_practice_complete.mp3';
import fluencyReminder from '../sounds/rct_fluency_reminder.mp3';
import fluencyPassageInstruction from '../sounds/rct_fluency_passage_instruction.mp3';
import fluencyPassageComplete from '../sounds/rct_fluency_passage_complete.mp3';

/* Comprehension audio */
import avatarComprehensionReady from '../sounds/rct_comprehension_ready.mp3';
import avatarComprehensionQuestion from '../sounds/rct_comprehension_question_instruction.mp3';

const RCT_AUDIO_INSTRUCTIONS = {
    ACCURACY: {
        accuracyQuestionsInstruction,
        accuracyReadyInstruction,
        avatarAnswers: [
            accuracyAnswerHot,
            accuracyAnswerPan,
            accuracyAnswerRib,
        ],
        avatarDirectionInstruction,
        avatarInstructionModel,
        avatarStart: accuracyPracticeStartInstruction,
        avatarStartModel,
        clickOk: AUDIO_INSTRUCTIONS.clickOk,
        commonReadyInstruction: AUDIO_INSTRUCTIONS.commonReadyInstruction,
        correctResponseInstruction: accuracyPracticeCorrectResponse,
        firstIncorrectInstruction: accuracyPracticeFirstIncorrect,
        secondIncorrectInstruction: accuracyPracticeSecondIncorrect,
    },
    FLUENCY: {
        ready: fluencyReady,
        directionInstruction: fluencyDirectionInstruction,
        modelInstruction: fluencyModelInstruction,
        modelInstructionReplay: fluencyModelInstructionReplay,
        modelAnswerInstruction: fluencyModelAnswerInstruction,
        modelComplete: fluencyModelComplete,
        practiceInstruction: fluencyPracticeInstruction,
        practiceComplete: fluencyPracticeComplete,
        clickOk: AUDIO_INSTRUCTIONS.clickOk,
        reminder: fluencyReminder,
        passageInstruction: fluencyPassageInstruction,
        passageComplete: fluencyPassageComplete,
    },
    COMPREHENSION: {
        avatarReady: avatarComprehensionReady,
        avatarQuestion: avatarComprehensionQuestion,
    },
};

export default RCT_AUDIO_INSTRUCTIONS;
